import request from '@/utils/request';

async function baseRequest(path, payload, method) {
  return request({
    url: `/deployment-service/blue_tooth${path}`,
    method,
    data: method === 'get' ? null : payload,
    params: method === 'get' ? payload : null,
  });
}

export function getBluetooth(payload) {
  return baseRequest('', payload, 'get');
}

export function actionBluetooth(payload) {
  return baseRequest('/pm', payload, 'post');
}

export function getTag(payload) {
  return baseRequest('/tag', payload, 'get');
}
